import { render, staticRenderFns } from "./IdeaScoreQuickTour.vue?vue&type=template&id=47cb4484"
import script from "./IdeaScoreQuickTour.vue?vue&type=script&lang=js"
export * from "./IdeaScoreQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports